/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ itemName: NonNullable<unknown> }} Notifications_Message_Subject_Any_ChangeInputs */

const he_notifications_message_subject_any_change = /** @type {(inputs: Notifications_Message_Subject_Any_ChangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`עדכון מחיר: ${i?.itemName}`)
};

const en_notifications_message_subject_any_change = /** @type {(inputs: Notifications_Message_Subject_Any_ChangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Price update: ${i?.itemName}`)
};

/**
* | output |
* | --- |
* | "Price update: {itemName}" |
*
* @param {Notifications_Message_Subject_Any_ChangeInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_message_subject_any_change = /** @type {((inputs: Notifications_Message_Subject_Any_ChangeInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Message_Subject_Any_ChangeInputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_message_subject_any_change(inputs)
	return en_notifications_message_subject_any_change(inputs)
});